import {Browser} from "@capacitor/browser";

export const openIosPaymentPage = async (orderId, type) => {
    const url = `https://caworld.org/payment.html?orderId=${orderId}&type=${type}`;
    await Browser.open({ url });
};